// Single source of truth for the canonical origin used in SEO metadata,
// canonical URLs, OpenGraph tags, and JSON-LD @id values.
//
// Falls back to the production origin so a missing build env can never
// emit `undefined/...` canonicals or fork the schema graph per environment.
const raw = process.env.REACT_APP_SITE_URL || 'https://acoord.co';
export const SITE_URL = String(raw).replace(/\/+$/, '');
